import { getAudioGraph } from './get-audio-graph';
import { getValueForKey } from './get-value-for-key';
export function getAudioParamConnections(context, audioParam) {
  var audioGraph = getAudioGraph(context);
  return getValueForKey(audioGraph.params, audioParam);
}